import React, { FunctionComponent, SVGProps } from 'react'

export const IconClose: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#858591"
    strokeWidth="1.5"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18 6L6 18" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6 6L18 18"
      strokeWidth={props.strokeWidth ?? '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
